import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import theme from "./module/theme"


export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    theme
    
  }
})